import AcceptanceReviewDetail from 'features/AcceptanceReview/pages/Detail';
import Layout from 'layout';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function AcceptanceReviewDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <AcceptanceReviewDetail />
      </Layout>
    </LayoutProvider>
  );
}
